import React from 'react'
import Button from '../button'
import { AdminUserDetail } from '../../../core/admin-users/admin-users'
import tableStyles from '../../styles/modules/table.module.scss'
import styles from '../../styles/modules/admin-users/admin-users.module.scss'

const AVAILABLE_ROLES = [
  { name: 'sbj_admin', label: '管理者' },
  { name: 'sbj_shop', label: '店舗' },
]

interface AdminUserInfoTableProps {
  adminUser: AdminUserDetail
  isEditing: boolean
  selectedRoleName: string
  onEditClick: () => void
  onRoleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
  onSave: () => void
  onCancel: () => void
}

const AdminUserInfoTable: React.FC<AdminUserInfoTableProps> = ({
  adminUser,
  isEditing,
  selectedRoleName,
  onEditClick,
  onRoleChange,
  onSave,
  onCancel,
}) => {
  return (
    <div className={styles.userTableContainer}>
      <h3 className={tableStyles.title}>管理ユーザー情報</h3>
      <div className={styles.buttonContainer}>
        {isEditing ? (
          <>
            <Button
              title="保存"
              onClick={onSave}
              className={styles.saveButton}
            />
            <Button
              title="キャンセル"
              onClick={onCancel}
              className={styles.cancelButton}
            />
          </>
        ) : (
          <Button
            title="編集"
            onClick={onEditClick}
            className={styles.editButton}
          />
        )}
      </div>
      <div className={tableStyles.wrapper}>
        <table className={`${tableStyles.container} ${styles.adminUserTable}`}>
          <tbody>
            <tr className={tableStyles.rowStatic}>
              <td className={tableStyles.cell}>メールアドレス</td>
              <td className={tableStyles.cell}>{adminUser.email}</td>
            </tr>
            <tr className={tableStyles.rowStatic}>
              <td className={tableStyles.cell}>名前</td>
              <td className={tableStyles.cell}>{adminUser.name || 'N/A'}</td>
            </tr>
            <tr className={tableStyles.rowStatic}>
              <td className={tableStyles.cell}>権限</td>
              <td className={tableStyles.cell}>
                {isEditing ? (
                  <select
                    value={selectedRoleName}
                    onChange={onRoleChange}
                    className={styles.roleSelect}
                  >
                    <option value="">権限を選択してください</option>
                    {AVAILABLE_ROLES.map(role => (
                      <option key={role.name} value={role.name}>
                        {role.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  AVAILABLE_ROLES.find(value => {
                    return value.name === adminUser.role
                  })?.label
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default AdminUserInfoTable
